<template>
    <HomeCard :title="$t('newHome.t2')" class="agent-box">
        <!-- 代办列表 -->
        <ul class="commission-list" :class="{'commission-list-dynamic': commissionShowListPage.length < 5}">
            <li v-for="(item, key) in commissionShowListPage" :key="key" class="item" @click="goRouter(item.router, item)">
                <div class="item-icon" :class="[item.icon]"></div>
                <div>
                    <p class="f1" :title="item.name">{{item.name}}</p>
                    <p class="f2" :title="item.value + $t('newHome.t7')">{{item.value > 99 ? '99+' : item.value}} <span>{{$t('newHome.t7')}}</span></p>
                </div>
            </li>
            <!-- <li class="item-edit" @click="editComissionList">
                <md-icon class="icon-common" name="md-icon-plus"></md-icon>
                <p class="f1">添加待办</p>
            </li> -->
        </ul>
    </HomeCard>
</template>
<script>
import axios from 'axios';
import HomeCard from './home-card.vue';

export default {
    name: 'myAgent',
    components: {
        HomeCard,
    },
    data() {
        return {
            commissionShowListPage: [
                {
                    name: this.$t('index.common.t1'),
                    value: 0,
                    icon: 'icon3',
                    router: 'deliveryNoticeConfirm',
                },
                {
                    name: this.$t('index.common.t2'),
                    value: 0,
                    icon: 'icon4',
                    router: 'createDeliveryOrderToInformView',
                },
            ],
        };
    },
    methods: {
        goRouter(name) {
            this.$router.push({
                name,
            });
        },
        queryUnComfirmNotifyCount() {
            axios.post('/gscint/order/queryUnComfirmNotifyCount', {
                vendorCode: this.vendorCode
            })
                .then((res) => {
                    this.commissionShowListPage[0].value = res.data.data.datas;
                });
        },
        queryComfirmNotifyNoOrderCount() {
            axios.post('/gscint/order/queryComfirmNotifyNoOrderCount', {
                vendorCode: this.vendorCode,
            })
                .then((res) => {
                    this.commissionShowListPage[1].value = res.data.data.datas;
                });
        },
    },
    mounted() {
        this.queryUnComfirmNotifyCount();
        this.queryComfirmNotifyNoOrderCount();
    },
};
</script>
<style lang="less" scoped>
   // 列表
    .commission-list {
        display: flex;
        // flex-wrap: wrap;
        padding-top: 27px;
        .item {
            cursor: pointer;
            display: flex;
            margin-bottom: 30px;
            margin-right: 50px;
            overflow: hidden;
            .item-icon {
                // flex: 0 0 48px;
                width: 48px;
                height: 48px;
                border-radius: 50%;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: 100% 100%;
                margin-right: 16px;
            }
            // 标题和数量宽度
            & > div {
                // width: calc(100% - 64px);
            }
            .f1 {
                font-size: 12px;
                width: 100%;
                color: #637381;
                margin-bottom: 4px;
                // white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .f2 {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                font-size: 22px;
                color: #161C24;
                font-weight: 600;
                span {
                    font-weight: 400;
                    color: #637381;
                    font-size: 12px;
                }
            }
        }
        .item-edit {
            width: 108px;
            height: 54px;
            background: #FFFFFF;
            border-radius: 2px;
            border: 1px dashed #C4CDD5;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            .icon-common {
                font-size: 16px;
                margin-right: 8px;
            }
        }
    }
    // 代办小于5个，即只占一行时，无需部分样式
    .commission-list-dynamic {
        .item {
            margin-bottom: 0px !important;
        }
        .icon-pre {
            left: -20px;
            top: 48%;
        }
    }

    // 图标样式 --- 新版本最多只有9个图标，即一页，存在icon9之后的样式是因为旧数据导致，所以在此兼容
    .icon1 {
        background-image: url('../../../../../assets/home/icon1.png');
    }
    .icon2 {
        background-image: url('../../../../../assets/home/icon2.png');
    }
    .icon3 {
        background-image: url('../../../../../assets/home/icon3.png');
    }
    .icon4 {
        background-image: url('../../../../../assets/home/icon4.png');
    }
    .icon5 {
        background-image: url('../../../../../assets/home/icon5.png');
    }
    .icon6 {
        background-image: url('../../../../../assets/home/icon6.png');
    }
    .icon7 {
        background-image: url('../../../../../assets/home/icon7.png');
    }
    .icon8 {
        background-image: url('../../../../../assets/home/icon8.png');
    }
    .icon9 {
        background-image: url('../../../../../assets/home/icon9.png');
    }
    .icon10 {
        background-image: url('../../../../../assets/home/icon10.png');
    }
    .icon11 {
        background-image: url('../../../../../assets/home/icon1.png');
    }
    .icon12 {
        background-image: url('../../../../../assets/home/icon2.png');
    }
</style>
